import { styled } from "twin.macro";

export const CreateTimelineWrapper = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
	@media (max-width: 1217px) {
		height: auto;
		${({ hide }) => hide && `display: none;`};
	}
`;
